import React, { useEffect } from "react";


export default function Bus(props) {
  const { device, editing, onChange } = props;
  const [fields, setFields] = React.useState({
    recorrido: device.recorrido ?? "",
    patente: device.patente ?? "",
    linea: device.linea ?? "",
    empresa: device.empresa ?? "",
    enabled: device.enabled ?? false,
    temperatureSensorId: device.temperatureSensorId ?? "",
    buttonDeviceId: device.buttonDeviceId ?? "",
    accelerometerDeviceId: device.accelerometerDeviceId ?? ""
  });
  const [, setTick] = React.useState(0);

  useEffect(() => {
    let interval = setInterval(() => setTick(tick => tick + 1), 30000);
    return () => clearInterval(interval);
  }, []);

  const fieldChanged = (name, value) => {
    let newFields = { ...fields, [name]: value };
    setFields(newFields);
    if (onChange) onChange(newFields);
  };

  if (editing) {
    return (
      <div>
        <h5 className="info-title">Recorrido</h5>
        <input
          type="text"
          className="form-control"
          defaultValue={device.recorrido}
          onChange={event => fieldChanged("recorrido", event.target.value)}
        />
        <h5 className="info-title">Patente</h5>
        <input
          type="text"
          className="form-control"
          defaultValue={device.patente}
          onChange={event => fieldChanged("patente", event.target.value)}
        />
        <h5 className="info-title">Línea</h5>
        <input
          type="text"
          className="form-control"
          defaultValue={device.linea}
          onChange={event => fieldChanged("linea", event.target.value)}
        />
        <h5 className="info-title">Empresa</h5>
        <input
          type="text"
          className="form-control"
          defaultValue={device.empresa}
          onChange={event => fieldChanged("empresa", event.target.value)}
        />
        <h5 className="info-title">ID Sensor de temperatura</h5>
        <input
          type="text"
          className="form-control"
          defaultValue={device.temperatureSensorId}
          onChange={event => fieldChanged("temperatureSensorId", event.target.value)}
        />
        <h5 className="info-title">ID Dispositivo Botón</h5>
        <input
          type="text"
          className="form-control"
          defaultValue={device.buttonDeviceId}
          onChange={event => fieldChanged("buttonDeviceId", event.target.value)}
        />
        <h5 className="info-title">ID Acelerómetro</h5>
        <input
          type="text"
          className="form-control"
          defaultValue={device.accelerometerDeviceId}
          onChange={event => fieldChanged("accelerometerDeviceId", event.target.value)}
        />
        <h5 className="info-title">
          <input
            type="checkbox"
            defaultChecked={device.enabled}
            onChange={event => fieldChanged("enabled", event.target.checked)}
          />
          {" Activo"}
        </h5>
      </div>
    );
  }

  let src = "img/device-features/bus.png";
  let responsive = device.lastReport && (Date.now() - new Date(device.lastReport).getTime()) < 2 * 60 * 1000;
  return (
    <div style={{ marginBottom: "10px" }}>
      <div className="row device-feature">
        <div className="col-8">
          <h5 className="feature-value-lbl">Recorrido: {device.recorrido}</h5>
          <h5 className="feature-value-lbl">Patente: {device.patente}</h5>
          <h5 className="feature-value-lbl">Línea: {device.linea}</h5>
          <h5 className="feature-value-lbl">Empresa: {device.empresa}</h5>
          {device.temperatureSensorId &&
            <h5 className="feature-value-lbl">Sensor temp.: {device.temperatureSensorId}</h5>}
          {device.buttonDeviceId &&
            <h5 className="feature-value-lbl">Botón: {device.buttonDeviceId}</h5>}
          {device.accelerometerDeviceId &&
            <h5 className="feature-value-lbl">Acelerómetro: {device.accelerometerDeviceId}</h5>}
        </div>
        <div className="col-4">
          <img src={src} alt="bus" width={50} height={50} />
        </div>
      </div>
      {device.enabled &&
        <h6 className={responsive ? "bus-status bus-status-on" : "bus-status bus-status-off"}>
          {responsive ? "Reportando" : "Sin reporte"}
        </h6>}
    </div>
  );

};
